import { createAction } from 'typesafe-actions';

import { RouterState } from './reducer';

export const updateLocation = createAction('router/UPDATE_LOCATION')<RouterState>();
